import * as React from 'react';
import * as moment from 'moment';
import * as firebase from "firebase";

import {Spin} from 'antd';

import Firebase, {withFirebase} from "../../components/Firebase";
import {ICourseFeedback} from "../../model/CourseFeedback";


interface IProps {
  courseSlug: string;
  firebase: Firebase;
}

interface IState {
  feedbacks: ICourseFeedback[] | 'loading';
}

class Feedbacks extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      feedbacks: 'loading'
    }
  }

  componentDidMount(): void {
    this.getFeedbacks();
  }

  getFeedbacks = () => {
    this.props.firebase.getCourseFeedbacks(this.props.courseSlug)
      .then((feedbacks: ICourseFeedback[]) => {
        this.setState(() => ({feedbacks}));
      })
      .catch((err) => {
        console.log(err);
      })
  };

  public render() {
    let {feedbacks} = this.state;
    if(feedbacks === 'loading') {
      return <Spin />
    }

    feedbacks = feedbacks.filter((feedback: ICourseFeedback) => feedback.feedbackText)

    const feedbacksList = feedbacks.map((feedback: ICourseFeedback) => {
      if (!feedback.feedbackText) {
        return;
      }
      const createdAt = (feedback.createdAt as firebase.firestore.Timestamp).seconds;

      return (
        <div className='feedback' key={createdAt}>
          <h4>Anonymous</h4>
          <p>
            {feedback.feedbackText}
          </p>
          <br/>
          <div className='feedback-details'>
            Difficulty: <strong>{feedback.difficulty} </strong>
            &bull; Usefulness: <strong>{feedback.usefulness} </strong>

            {feedback.grade && <span>&bull; Grade: <strong>{feedback.grade} </strong></span>}
            {(feedback.semester || feedback.year) && <span> &bull; {feedback.semester} {feedback.year} </span>}

            <span className='secondary-text fr'>
              {moment.unix(createdAt).fromNow()}
            </span>

          </div>

          <span className='clear'/>

        </div>
      )
    });

    return(
      <div>
        <h4>Only feedbacks with text are listed there</h4>
        {feedbacksList}
      </div>
    )
  }
}

export default withFirebase(Feedbacks);